import { Component, OnInit, TemplateRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../services/constants"
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UsernameValidator } from "../../services/NoWhiteSpace.validator";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-groups",
  templateUrl: "./groups.component.html",
  styleUrls: ["./groups.component.css"]
})
export class GroupsComponent implements OnInit {
  groupsData:any = [];
  currentPage:number | undefined;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  sortType: any;
  sortBy : string = ""
  orderBy: string = "2";
  search="";
  closeSearch:boolean = false;
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: true
  };
  accessData:any = [];
  allData:any = [];
  groupForm: FormGroup;
  showError = false;
  groupID:any;
  accessList = [
		{
			name: "Jobs",
			placeholder : [
				{title: "Create Job", key: "createJob", permission:0},
				{title: "View Team Member’s jobs", key: "viewTeamMemberJob", permission:0},
				{title: "Edit Team Member’s Jobs", key: "editTeamMemberJob", permission:0},
			]
		},
    {
			name: "Team",
			placeholder : [
				{title: "Add Team Member", key: "addTeamMember", permission:0},
				{title: "Edit Team Member", key: "editTeamMember", permission:0},
				{title: "Delete Team Member", key: "deleteTeamMember", permission:0},
			]
		},
    {
			name: "Licensing",
			placeholder : [
				{title: "View Active Plan and Inventory", key: "viewActivePlans", permission:0},
				{title: "View Invoice and Purchase History", key: "viewInvoice", permission:0},
				{title: "Buy Inventory", key: "buyInventory", permission:0},
        {title: "Cancel Subscriptions", key: "cancelSubscription", permission:0},
			]
		},
  ] 

  constructor(private toastrService: ToastrService,private formBuilder: FormBuilder,private modalService: BsModalService,public route: ActivatedRoute, private router: Router,private api: AdminService) { 
    this.groupForm = this.formBuilder.group({
      groupName: ["", Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(30),UsernameValidator.cannotContainSpace])],
      groupDescription: ["", Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(250),UsernameValidator.cannotContainSpace])],
    });
  }

  ngOnInit(): void {
    this.getAllGroups();
  }

  getAllGroups(){
    let params = new HttpParams(); 
    params = params.append("skip", this.pagination.skip.toString());
    params = params.append("limit", this.pagination.limit.toString());
    if (this.search != null && this.search != "") {
      params = params.append("search", this.search);
    }
    if (this.sortBy) { params = params.append("sortBy",this.sortBy.trim() ? this.sortBy.trim() : "");
      params = params.append("orderBy", this.orderBy == "ASC" ? "ASC" : "DESC");
    }
    this.api.getData(apiUrl._groupPermission,params)
    .subscribe(async (res) => {
      this.pagination.totalItems = res.data.count; 
      this.groupsData = res.data.groupPermission;
    })
  }
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getAllGroups();
  }
  searchFun() {  
    this.currentPage = 1;
    this.pagination.skip = 0; 
    this.closeSearch = true; 
    if(this.groupsData.length > 0){
    this.getAllGroups(); }
    }
  clearSearch() {
    this.search= "";
    this.closeSearch = false;
    this.pagination.skip = 0; 
    localStorage.removeItem("type-redirect");
    // if(this.groupsData.length > 0){
      this.getAllGroups(); 
    // } 
  }
  // === Modal ====
  openModal(template: TemplateRef<any>,id:any) {
    this.groupID = id;
    this.getGroupDetails(this.groupID)
    this.modalRef = this.modalService.show(
      template,
      Object.assign({},this.config, { class: "modal-lg addModal" })
    );
  }
  closeModal(){ 
    this.modalService.hide();
  }

// ================= Edit Group Detail ==================
  getGroupDetails(id){
    this.api.getData(apiUrl._groupDetail + "/" + id, "")
      .subscribe(
        async (res) => {
          this.allData = res.data;
          this.groupForm.patchValue({
            groupName: this.allData.groupName,
            groupDescription: this.allData.groupDescription,
          });
          const group:any=[];
          group.push(this.allData)
          Object.entries(group[0]).forEach(entry => {
            const [key, value] = entry
            for(let i=0; i< this.accessList.length;i++){
              for(let j = 0; j < this.accessList[i].placeholder.length; j++){
                if (key == this.accessList[i].placeholder[j].key && value == 1){
                  this.accessList[i].placeholder[j].permission = 1
                }
              }
            }
          })
        },
        (err) => {
          console.log(err.error.message, "error");
        }
      );
  }

  // =========== Submit Group Info ===========
  submitGroup(){
    if(this.groupForm.valid){
      const data = {
        "id": this.groupID,
        "groupName": this.capitalizeFirstLetter(this.groupForm.value.groupName),
        "groupDescription": this.capitalizeFirstLetter(this.groupForm.value.groupDescription),
      }
      this.api.putData(apiUrl._groupPermission, data).subscribe(() => {
        this.closeModal();
        this.toastrService.success("Permissions updated successfully.");
        this.getAllGroups();
			})
    }else {
			this.showError = true 
			setTimeout(() => {this.showError = false}, 5000  )
		}
  }

  // =========== Submit Group Permission =================
  submitGroupPermission(){
    let creatJob:any;
    let viewTeamMemberJob:any;
    let editTeamMemberJob:any;
    let addTeamMember:any;
    let editTeamMember:any;
    let deleteTeamMember:any;
    let viewActivePlans:any;
    let buyInventory:any;
    let viewInvoice:any;
    let cancelSubscription:any;
    for(let i = 0 ; i < this.accessList.length ; i++){
      for(let j = 0; j < this.accessList[i].placeholder.length; j++){
        if(this.accessList[i].placeholder[j].permission == 1 || this.accessList[i].placeholder[j].permission == 0){
          if(this.accessList[i].placeholder[j].key == "createJob"){
            creatJob = this.accessList[i].placeholder[j].permission
          }
          if(this.accessList[i].placeholder[j].key == "viewTeamMemberJob"){
            viewTeamMemberJob = this.accessList[i].placeholder[j].permission
          }
          if(this.accessList[i].placeholder[j].key == "editTeamMemberJob"){
            editTeamMemberJob = this.accessList[i].placeholder[j].permission
          }
          if(this.accessList[i].placeholder[j].key == "addTeamMember"){
            addTeamMember = this.accessList[i].placeholder[j].permission
          }
          if(this.accessList[i].placeholder[j].key == "editTeamMember"){
            editTeamMember = this.accessList[i].placeholder[j].permission
          }
          if(this.accessList[i].placeholder[j].key == "deleteTeamMember"){
            deleteTeamMember = this.accessList[i].placeholder[j].permission
          }
          if(this.accessList[i].placeholder[j].key == "viewActivePlans"){
            viewActivePlans = this.accessList[i].placeholder[j].permission
          }
          if(this.accessList[i].placeholder[j].key == "buyInventory"){
            buyInventory = this.accessList[i].placeholder[j].permission
          }
          if(this.accessList[i].placeholder[j].key == "viewInvoice"){
            viewInvoice = this.accessList[i].placeholder[j].permission
          }
          if(this.accessList[i].placeholder[j].key == "cancelSubscription"){
            cancelSubscription = this.accessList[i].placeholder[j].permission
          }
        }
      }
    }
    const data = {
      "id": this.groupID,
      "createJob": creatJob,
      "viewTeamMemberJob": viewTeamMemberJob,
      "editTeamMemberJob": editTeamMemberJob,
      "addTeamMember": addTeamMember,
      "editTeamMember": editTeamMember,
      "deleteTeamMember": deleteTeamMember,
      "viewActivePlans": viewActivePlans,
      "buyInventory": buyInventory,
      "viewInvoice": viewInvoice,
      "cancelSubscription": cancelSubscription,
    }
    this.api.putData(apiUrl._groupPermission, data).subscribe(() => {
      this.closeModal();
      this.toastrService.success("Permissions updated successfully.");
    })
  }
  
  capitalizeFirstLetter(value: any) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  clickEvent(i,j){
		this.accessList[i].placeholder[j].permission = this.accessList[i].placeholder[j].permission == 0 ? 1 : 0
	}
}